import { render } from "./ColorChooserBar.vue?vue&type=template&id=b9f70f80&scoped=true"
import script from "./ColorChooserBar.vue?vue&type=script&lang=js"
export * from "./ColorChooserBar.vue?vue&type=script&lang=js"

import "./ColorChooserBar.vue?vue&type=style&index=0&id=b9f70f80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9f70f80"

export default script